import React, { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch } from 'react-instantsearch-dom';

import ClearRefinementsButton from '../../algolia_search/clear_refinements_button';
import HashtagFilterPanel from './filter_panels/hashtag_filter_panel';
import InfiniteHits from './infinite_hits';
import MenuBar from '../../directory/MenuBar';
import ShowIfAnyRefinements from './show_if_any_refinements';
import SiteFilterPanel from './filter_panels/site_filter_panel';
import SmartStats from '../../algolia_search/smart_stats';
import { DebouncedSearchBox } from '../../debounced_search_box';

function PressReleasesIndex({
                              algoliaAppId,
                              algoliaSearchKey,
                              indexName,
                              query,
                              view,
                              showMenuBar,
                              currentUserSlug,
                            }) {
  const searchBoxRef = useRef(null);

  const searchClient = useMemo(
    () => algoliasearch(algoliaAppId, algoliaSearchKey),
    [algoliaAppId, algoliaSearchKey],
  );

  return (
    <div className="ais-InstantSearch mt-3">
      <InstantSearch indexName={indexName} searchClient={searchClient}>
        <MenuBar view={view} showNav={showMenuBar}>
          {{
            searchForm: (
              <>
                <DebouncedSearchBox
                  ref={searchBoxRef}
                  autoFocus
                  translations={{ placeholder: 'Search' }}
                  defaultRefinement={query}
                  className="d-flex me-3"
                />
                <ClearRefinementsButton
                  bootstrapClasses="px-3 btn btn-sm btn-outline-info text-nowrap"
                  buttonText="Clear"
                  clearsQuery={true}
                  onClear={() => searchBoxRef.current?.clearQuery()}
                />
              </>
            ),
            buttons: !showMenuBar && currentUserSlug && (
              <div className="d-flex justify-content-end align-items-end">
                <a href={`/users/${currentUserSlug}/source_press_releases`} className="me-3 btn btn-large btn-outline-primary">
                  <i className="fa fa-files me-3" />
                  My Press Releases
                </a>
                <a href={`/users/${currentUserSlug}/source_press_releases/new`} className="btn btn-large btn-primary">
                  <i className="fa fa-plus text-white me-3" />
                  Add Press Release
                </a>
              </div>
            ),
          }}
        </MenuBar>

        <div className="row mb-2">
          <div className="col pe-4 text-end">
            <SmartStats />
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-3">
            <SiteFilterPanel />
            <HashtagFilterPanel />
          </div>

          <div className="col-12 col-md-9">
            <ShowIfAnyRefinements clearsQuery={true}>
              <div className="row mb-3">
                <div className="col">
                  <ClearRefinementsButton
                    buttonText="Clear search &#38; filters"
                    clearsQuery={true}
                    onClear={() => searchBoxRef.current?.clearQuery()}
                  />
                  <div className="d-inline-block ms-3">
                    <SmartStats />
                  </div>
                </div>
              </div>
            </ShowIfAnyRefinements>

            <div className="row">
              <div className="col">
                <InfiniteHits />
              </div>
            </div>
          </div>
        </div>
      </InstantSearch>
    </div>
  );
}

PressReleasesIndex.propTypes = {
  query: PropTypes.string,
  algoliaAppId: PropTypes.string.isRequired,
  algoliaSearchKey: PropTypes.string.isRequired,
  indexName: PropTypes.string.isRequired,
  view: PropTypes.string,
  showMenuBar: PropTypes.bool,
  currentUserSlug: PropTypes.string,
};

PressReleasesIndex.defaultProps = {
  query: '',
  view: 'pressreleases',
  showMenuBar: true,
  currentUserSlug: undefined,
};

export default PressReleasesIndex;
